<app-loading
  [loading] = loading
></app-loading>
<app-header></app-header>
<app-sidebar></app-sidebar>
<div class="content-wrapper">
  <section class="content">
    <app-breadcrumb
      Pagina="Detalhes"
      [TemPaginaPai] = true
      LinkPaginaPai="/juridico/processo"
      PaginaPai="Processos"
    ></app-breadcrumb>
    <div class="row">
      <div class="col-md-12">
        <div class="card" style="min-height: 500px">
          <div class="card-body" >
            <div class="row" style="min-height: 150px">
              <div class="col-md-12">
                <div class="row">
                  <div class="col-md-12">
                    <h2 class="text-blue">{{processo.titulo}}</h2>
                    <div class="info-gerais">
                      Processo | {{processo.numeroProcesso}}
                      <br>Pasta: {{processo.pastaNome}}
                      <br>Cliente: {{processo.cliente}}
                      <br>Status: <span *ngIf="processo.status == 0">Aberto</span>
                      <span *ngIf="processo.status == 1">Oficio</span>
                      <span *ngIf="processo.status == 2">Fechado</span>
                      <span *ngIf="processo.status == 3">Aguardando sentença</span>
                      <span *ngIf="processo.status == 4">Aguardando audiência</span>
                      <span *ngIf="processo.status == 5"></span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-8">
                <div class="row">
                  <div class="col-md-12 mb-3">
                    <div class="card card-blue card-outline">
                      <div class="card-header">
                        <h3 class="card-title"><i class="fa fa-balance-scale"></i> Detalhes do processo</h3>
                        <div class="card-tools">
                          <button type="button" class="btn btn-tool" data-card-widget="collapse">
                            <i class="fa fa-minus"></i>
                          </button>
                        </div>
                      </div>
                      <div class="card-body" style="display: block;">
                          <div class="row">
                            <div class="form-group col-md-12 mb-3">
                              <div class="form-group">
                                <label for="nomeOutraParte">Outros envolvidos</label>
                                <div class="custom-select-container">
                                  <i class="fa fa-user-secret icon"></i>
                                  <input type="text" [(ngModel)]="processo.nomeOutraParte" id="nomeOutraParte" class="form-control">
                                </div>
                              </div>
                            </div>
                            <div class="col-md-5 mb-3">
                              <div class="form-group">
                                <label for="numeroProcesso">Numero do Processo</label>
                                <div class="custom-select-container">
                                  <i class="fa fa-id-card icon"></i>
                                  <input type="text" [(ngModel)]="processo.numeroProcesso" id="numeroProcesso" class="form-control">
                                </div>
                              </div>
                            </div>
                            <div class="col-md-7 mb-3">
                              <div class="form-group">
                                <label for="titulo">Titulo</label>
                                <div class="custom-select-container">
                                  <i class="fa fa-font icon"></i>
                                  <input type="text" [(ngModel)]="processo.titulo" id="titulo" class="form-control">
                                </div>
                              </div>
                            </div>
                            <div class="col-md-6 mb-3">
                              <div class="form-group">
                                <label for="valorCausa">Valor Causa</label>
                                <div class="custom-select-container">
                                  <i class="fa fa-money icon"></i>
                                  <input type="text" [(ngModel)]="processo.valorCausa" id="valorCausa" class="form-control">
                                </div>
                              </div>
                            </div>
                            <div class="col-md-6 mb-3">
                              <div class="form-group">
                                <label for="valorCondenacao">Valor Condenação</label>
                                <div class="custom-select-container">
                                  <i class="fa fa-money icon"></i>
                                  <input type="text" [(ngModel)]="processo.valorCondenacao" id="valorCondenacao" class="form-control">
                                </div>
                              </div>
                            </div>
                            <div class="col-md-8 mb-3">
                              <div class="form-group">
                                <label for="juiz">Juiz</label>
                                <div class="custom-select-container">
                                  <i class="fa fa-user-plus icon"></i>
                                  <input type="text" [(ngModel)]="processo.juiz" id="juiz" class="form-control">
                                </div>
                              </div>
                            </div>
                            <div class="col-md-4 mb-3">
                              <div class="form-group">
                                <label for="tipoAcao">Ação</label>
                                <div class="custom-select-container">
                                  <i class="fa fa-balance-scale icon"></i>
                                  <ng-select [items]="listaTipoAcao"
                                             bindLabel="descricao"
                                             bindValue="id"
                                             [(ngModel)]="processo.tipoAcao"
                                             [clearable]="false"
                                             placeholder="Selecione"
                                             id="tipoAcao">
                                  </ng-select>
                                </div>
                              </div>
                            </div>
                            <div class="col-md-12">
                              <div class="form-group">
                                <label for="descricao">Objeto:</label>
                                <angular-editor id="descricao"
                                                [config]="editorConfig"
                                                [(ngModel)]="processo.descricao"></angular-editor>
                              </div>
                            </div>
                          </div>
                      </div>

                      <div class="card-footer" style="display: block;">
                        <div class="col-md-12 text-center"><button (click)="salvarAlteracoes()" class="btn btn-primary">Salvar</button></div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-12 mb-3">
                    <div class="card card-blue card-outline">
                      <div class="card-header">
                        <h3 class="card-title"><i class="fa fa-exchange"></i> Histórico de Movimentações</h3>
                        <div class="card-tools">
                          <button type="button" class="btn btn-tool" data-card-widget="collapse">
                            <i class="fa fa-minus"></i>
                          </button>
                        </div>
                      </div>
                      <div class="card-body" style="display: block;">
                      <div class="row">
                        <div class="col-md-12" *ngFor="let item of processo.movimentacoes">
                          {{item.dataCadastro | date: "dd/MM/yyyy HH:mm:ss"}} - {{item.usuarioNome}} - Tipo de movimentação:{{item.tipoNome}}
                        </div>
                      </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-4">
               <div class="row">
                 <div class="col-md-12 mb-3">
                   <div class="card card-blue card-outline">
                     <div class="card-header">
                       <h3 class="card-title"><i class="fa fa-file-word-o"></i> Documentos</h3>
                       <div class="card-tools">
                         <button type="button" class="btn btn-tool" (click)="abrirModalNovoDocumento()">
                           <i class="fa fa-plus"></i>
                         </button>
                         <span class="badge bg-blue">{{ processo.totalDocumentos }}</span>

                         <button type="button" class="btn btn-tool" data-card-widget="collapse">
                           <i class="fa fa-minus"></i>

                         </button>
                       </div>
                     </div>
                     <div class="card-body" style="display: block;">
                       <table class="table table-bordered table-striped">
                         <tbody *ngIf="processo.totalDocumentos > 0">
                          <tr *ngFor="let item of processo.documentos">
                            <td (click)="download(item.id, item.descricao, item.extensao)">
                              <div class="row" style="cursor:pointer;">
                                <div class="col-md-9"> <a target="_blank" >{{item.descricao}}</a></div>
                                <div class="col-md-3" style="text-align: right; color: #193043" ><i class="fa fa-download"></i></div>
                              </div>
                            </td>
                          </tr>
                         </tbody>
                         <tbody *ngIf="processo.totalDocumentos <= 0">
                         <tr>
                           <td>Sem documentos cadastrados</td>
                         </tr>
                         </tbody>
                       </table>
                     </div>
                   </div>
                 </div>

                 <!-- Card de Audiências -->
                 <div class="col-md-12 mb-3">
                   <div class="card card-blue card-outline">
                     <div class="card-header">
                       <h3 class="card-title"><i class="fa fa-gavel"></i> Audiências</h3>
                       <div class="card-tools">
                         <button type="button" class="btn btn-tool" (click)="abrirModalNovaAudiencia()">
                           <i class="fa fa-plus"></i>
                         </button>
                         <span class="badge bg-blue">{{ totalAudiencias }}</span>
                         <button type="button" class="btn btn-tool" data-card-widget="collapse">
                           <i class="fa fa-minus"></i>
                         </button>
                       </div>
                     </div>
                     <div class="card-body" style="display: block;">
                       <table class="table table-bordered table-striped">
                         <tbody *ngIf="totalAudiencias > 0">
                         <tr *ngFor="let item of listaAudiencias">
                           <td>
                             <div class="row">
                               <div class="col-md-8">
                                 <a [routerLink]="['/juridico/audiencia/detalhes', item.id]" class="text-decoration-none text-dark">
                                   <span>{{ item.dataInicio | date: 'dd/MM/yyyy HH:mm' }}</span>
                                   <span> - {{ item.local }}</span>
                                 </a>
                               </div>
                               <div class="col-md-4 text-right">
                                 <span class="badge" [ngClass]="{
                                   'bg-blue': item.status === 0,
                                   'bg-success': item.status === 1,
                                   'bg-danger': item.status === 2
                                 }">{{ item.status === 0 ? 'Agendada' : item.status === 1 ? 'Realizada' : 'Cancelada' }}</span>
                               </div>
                             </div>
                           </td>
                         </tr>
                         </tbody>
                         <tbody *ngIf="totalAudiencias <= 0">
                         <tr>
                           <td>Sem audiências cadastradas</td>
                         </tr>
                         </tbody>
                       </table>
                     </div>
                   </div>
                 </div>

                 <div class="col-md-12 mb-3">
                   <div class="card card-blue card-outline">
                     <div class="card-header">
                       <h3 class="card-title"><i class="fa fa-check-circle-o"></i> Tarefas</h3>
                       <div class="card-tools">
                         <button type="button" class="btn btn-tool" (click)="abrirModalNovaTarefa()">
                           <i class="fa fa-plus"></i>
                         </button>
                         <span class="badge bg-blue">{{ processo.totalTarefas }}</span>
                         <button type="button" class="btn btn-tool" data-card-widget="collapse">
                           <i class="fa fa-minus"></i>
                         </button>
                       </div>
                     </div>
                     <div class="card-body" style="display: block;">
                       <table class="table table-bordered table-striped">
                         <tbody *ngIf="processo.totalTarefas > 0">
                         <tr *ngFor="let item of processo.tarefas">
                           <td style="cursor: pointer" (click)="buscarDetalheTarefa(item.id)">{{item.dataCadastro | date:"dd-MM-yyyy" }}
                             | {{item.descricao}} | Responsável: {{item.responsavel}}</td>
                         </tr>
                         </tbody>
                         <tbody *ngIf="processo.totalTarefas <= 0">
                         <tr>
                           <td>Sem tarefas cadastradas</td>
                         </tr>
                         </tbody>
                       </table>
                     </div>

                   </div>
                 </div>
                 <div class="col-md-12 mb-3">
                   <div class="card card-blue card-outline">
                     <div class="card-header">
                       <h3 class="card-title"><i class="fa fa-check-circle-o"></i> Atendimentos</h3>
                       <div class="card-tools">
                         <button type="button" class="btn btn-tool" (click)="abrirModalNovoAtendimento()">
                           <i class="fa fa-plus"></i>
                         </button>
                         <span class="badge bg-blue">{{ processo.totalAtendimentos }}</span>
                         <button type="button" class="btn btn-tool" data-card-widget="collapse">
                           <i class="fa fa-minus"></i>
                         </button>
                       </div>
                     </div>
                     <div class="card-body" style="display: block;">
                       <table class="table table-bordered table-striped">
                         <tbody *ngIf="processo.totalAtendimentos > 0">
                           <tr *ngFor="let item of processo.atendimentos">
                             <td><a  target="_blank" href="cadastro/atendimento/detalhes/{{item.id}}">{{item.dataCadastro | date:"dd-MM-yyyy"  }} | {{item.descricaoResumida}}</a></td>
                           </tr>
                         </tbody>
                         <tbody *ngIf="processo.totalAtendimentos <= 0">
                         <tr>
                           <td>Sem atendimentos cadastrados</td>
                         </tr>
                         </tbody>
                       </table>
                     </div>
                   </div>
                 </div>
               </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Modais/Auxiliares -->
    <app-novo-audiencia [isModal]="true" (atualizarLista)="buscarAudienciasPorProcesso(id)"></app-novo-audiencia>

  </section>
</div>
<app-detalhes
  (atualizarLista)="buscarProcessoPorId(id)"
>
</app-detalhes>

<!-- Modal Novo Documento -->
<app-novo-documento-processo
  [isModal]="true"
  (atualizarLista)="buscarProcessoPorId(id)"
></app-novo-documento-processo>

<!-- Modal Nova Tarefa -->
<app-nova
  [telaProcesso]="true"
  [processoId]="id"
  (atualizarLista)="buscarProcessoPorId(id)">
</app-nova>

<!-- Modal Novo Atendimento -->
<app-novo-atendimento
  [isModal]="true"
  (atualizarLista)="buscarProcessoPorId(id)">
</app-novo-atendimento>
